// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"style__iconWrapper__n2OaW","icon":"style__icon__QUjK3"};